// extracted by mini-css-extract-plugin
export default {"root":"customPageHeaderView_root__NyGTw","nonProviderRoot":"customPageHeaderView_nonProviderRoot__m7we3","providerRoot":"customPageHeaderView_providerRoot__lTUNi"};